import { render, staticRenderFns } from "./AttachedMenu.vue?vue&type=template&id=3b9f1be8&scoped=true"
import script from "./AttachedMenu.vue?vue&type=script&lang=js"
export * from "./AttachedMenu.vue?vue&type=script&lang=js"
import style0 from "./AttachedMenu.vue?vue&type=style&index=0&id=3b9f1be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f1be8",
  null
  
)

export default component.exports